let loader = document.querySelector(".collection-loader");
let filterOptions = document.querySelectorAll(".filter-option");
let priceFilters = document.querySelectorAll(".price-filter");
let sortSelect = document.querySelector(".sort-collection");
let cardView = document.querySelector(".card-view");
let maxPriceInput = document.querySelector(".price-filter.max");
let minPriceInput = document.querySelector(".price-filter.min");
let filterButton = document.querySelector(".filter-btn");
let currentPage = window.location.search.includes("page")
  ? window.location.search.match(/page=(\d+)/)[0].match(/\d+/)[0]
  : "1";
let currentSort = window.location.search.includes("sort_by")
  ? window.location.search.substring(
      window.location.search.indexOf("sort_by=") + "sort_by=".length
    )
  : "";
let filterObjectArray = [];
let priceFilterArray = [];
let filterContainers = document.querySelectorAll(".filter-block-wrap");

filterContainers.forEach(container => {
  container.classList.add("open");
});


// Function to apply filters for mobile display
function applyFiltersMobile() {
  currentPage = 1;
  filterObjectArray = [];

  // Iterate over filter options and apply filters
  filterOptions.forEach(function (el, ind) {
    let filter = {
      type: el.dataset.param,
      value: el.dataset.value,
    };
    if (el.checked) {
      filterObjectArray.push(filter);
    } 
  });

  // Generate URL and update it
  generateUrl();
}

// Function to apply filters for larger display
function applyFiltersDesktop() {
  currentPage = 1;
  filterObjectArray = [];

  // Iterate over filter options and apply filters
  filterOptions.forEach(function (el, ind) {
    el.addEventListener("change", function (e) {
      let filter = {
        type: el.dataset.param,
        value: el.dataset.value,
      };
      if (el.checked) {
        filterObjectArray.push(filter);
      } else {
        filterObjectArray = filterObjectArray.filter(
          (el) => el.value != filter.value
        );
      }
      generateUrl();
    });
  });
}

// Function to get current filters
function getCurrentFilters() {
  let searchParams = window.location.search.replace("?", "");
  if (searchParams.includes("filter")) {
    let filterArray = searchParams.includes("&")
      ? searchParams.split("&")
      : [searchParams];
    filterArray.forEach(function (el, ind) {
      if (el.includes("filter") && !el.includes("price")) {
        let object = {
          type: el.split("=")[0],
          value: el.split("=")[1],
        };
        filterObjectArray.push(object);
      }
    });
  }
}



// Use matchMedia to check display width and apply filters accordingly
const mediaQuery = window.matchMedia("(max-width: 990px)");

if (mediaQuery.matches) {
  // Execute for mobile display
  // Add a click event listener to the filter button for mobile
  if (filterButton) {
    filterButton.addEventListener("click", applyFiltersMobile);
  }
  // applyFiltersMobile();
  // applyFiltersDesktop();
} else {
  // Execute for larger display
  applyFiltersDesktop();
}

// Call getCurrentFilters for both scenarios
getCurrentFilters();


function generateUrl() {
  let filterUrl = "";
  currentSort = currentSort.includes("&")
    ? currentSort.split("&")[0]
    : currentSort;
  filterObjectArray.forEach(function (el, ind) {
    ind == 0
      ? (filterUrl += `?${el.type}=${el.value}`)
      : (filterUrl += `&${el.type}=${el.value}`);
  });
  priceFilterArray.length > 1
    ? priceFilterArray.forEach(function (el, ind) {
        filterUrl.includes("?")
          ? (filterUrl += `&${el.type}=${el.value}`)
          : (filterUrl += `?${el.type}=${el.value}`);
      })
    : "";
  filterUrl.includes("?")
    ? (filterUrl += `&page=${currentPage}`)
    : (filterUrl += `?page=${currentPage}`);
  currentSort.trim().length > 1 ? (filterUrl += `&sort_by=${currentSort}`) : "";
  console.log(filterUrl);
  updateUrl(filterUrl);
}

function updateUrl(url) {
  let currentPath = window.location.pathname;
  url.trim().length >= 1
    ? window.history.pushState("", "", url)
    : window.history.pushState("", "", currentPath);
  let fetchUrl = window.location.pathname + window.location.search;
  fetchUrl.includes("?")
    ? (fetchUrl += `&view=ajax`)
    : (fetchUrl += `?viewajax`);
  fetchProducts(fetchUrl);
}

function fetchProducts(url) {
  loader.classList.add("active");
  console.log(url);
  fetch(url)
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let html = parser.parseFromString(data, "text/html");
      // console.log(html)
      let productCardHtml = html.querySelector(
        ".collection-products-list-wrap"
      ).innerHTML;
      let activeFiltersHtml = html.querySelector(".active-filters").innerHTML;
      let paginateHtml = html.querySelector(".paginate-wrap").innerHTML;
      let a_list = html.querySelectorAll(".paginate-wrap a");
      let page_count = 0;
      // console.log(a_list)
      a_list.forEach((item) => {
          let dataPage = item.getAttribute('data-part');
          // console.log(dataPage)
          if (dataPage !== null) {
              let pageNumber = parseInt(dataPage);
              if (!isNaN(pageNumber) && pageNumber > page_count) {
                  page_count = pageNumber;
              }
          }
      });
      // console.log("Largest data-page value:", page_count);
      document.querySelector("input[data-total-pages]").value = page_count;
      document.querySelector(".collection-products-list-wrap").innerHTML = "";
      document.querySelector(".active-filters").innerHTML = "";
      // document.querySelector(".paginate-wrap").innerHTML = "";
      document.querySelector(".collection-products-list-wrap").innerHTML =
        productCardHtml;
      document.querySelector(".active-filters").innerHTML = activeFiltersHtml;
      // document.querySelector(".paginate-wrap").innerHTML = paginateHtml;
      let productCountText = document.querySelector('.section-heading .product-count');
      console.log('count is ', productCountText)
      if (productCountText.innerHTML !== "") {
        productCountText.style.display = "none";
      }
      loader.classList.remove("active");
      disableUnavailableVariantCollection();
    })
    .catch((err) => console.error(err));
}

//////////////////////////Price filter
const updateprice = filterDebounce(() => {
  priceFilterArray = [];
  priceFilters.forEach(function (el, ind) {
    let priceData = {
      type: el.dataset.value,
      value: el.value,
    };
    priceFilterArray.push(priceData);
  });
  generateUrl();
});

priceFilters.forEach(function (el, ind) {
  el.addEventListener("change", function () {
    updateprice();
    currentPage = 1;
  });
});

function filterDebounce(callback) {
  let timer;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      callback(...args);
    }, 1000);
  };
}

///////////////////////////sorting
if (sortSelect) {
  sortSelect.addEventListener("change", function () {
    currentSort = this.value;
    generateUrl();
  });
}
//////////////////////////////Card view change
if(cardView){
  cardView.addEventListener("change", function (e) {
    let rootStyle = document.querySelector(":root");
    rootStyle.style.setProperty("--collection-cards-row-desktop", this.value);
  });
}
/////////////////////////////Price range bar
var lowerSlider = document.querySelector("#lower"),
  upperSlider = document.querySelector("#upper"),
  lowerVal = parseInt(lowerSlider.value);
upperVal = parseInt(upperSlider.value);

upperSlider.oninput = function () {
  lowerVal = parseInt(lowerSlider.value);
  upperVal = parseInt(upperSlider.value);
  maxPriceInput.value = upperVal;
  minPriceInput.value = lowerVal;
  let event = new Event("change");
  maxPriceInput.dispatchEvent(event);
  minPriceInput.dispatchEvent(event);
  if (upperVal < lowerVal + 4) {
    lowerSlider.value = upperVal - 4;

    if (lowerVal == lowerSlider.min) {
      upperSlider.value = 4;
    }
  }
};

lowerSlider.oninput = function () {
  lowerVal = parseInt(lowerSlider.value);
  upperVal = parseInt(upperSlider.value);
  maxPriceInput.value = upperVal;
  minPriceInput.value = lowerVal;
  let event = new Event("change");
  maxPriceInput.dispatchEvent(event);
  minPriceInput.dispatchEvent(event);
  if (lowerVal > upperVal - 4) {
    upperSlider.value = lowerVal + 4;

    if (upperVal == upperSlider.max) {
      lowerSlider.value = parseInt(upperSlider.max) - 4;
    }
  }
};
//////////////////////Filters expand and shrink toggle
// document.addEventListener("click",(e)=>{
//   if(e.target.classList.contains("filter-button") || e.target.closest(".filter-button") || e.target.classList.contains("load-filters") || e.target.closest(".load-filters") ){
//     let el = e.target;
//     let filterWrap = el.closest(".filter-block-wrap");
//     filterWrap.classList.toggle("open")
//   }
// })

